/* eslint-disable prefer-rest-params */
import { constants } from '../config';

class GA4 {
  static injectGoogleAnalytics() {
    if (typeof window !== 'undefined' && !window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${constants.googleAnalytics4Id}`;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', constants.googleAnalytics4Id);
      };
    }
  }

  static viewItemList(items) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'view_item_list', {
      currency: 'UYU',
      items,
    });
  }

  static viewItemEvent(price, item) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'view_item', {
      currency: 'UYU',
      value: price,
      items: [item],
    });
  }

  static searchEvent(searchTerm) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'search', {
      search_term: searchTerm,
    });
  }

  static addToCartEvent(amount, productName, itemId, quantity) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'add_to_cart', {
      currency: 'UYU',
      value: amount,
      items: [
        {
          item_name: productName.trim(),
          item_id: itemId,
          price: amount,
          quantity,
        },
      ],
    });
  }

  static pursacheEvent(transactionId, amount, shipmentAmount, paymentType, items, userId) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: amount,
      currency: 'UYU',
      shipping: shipmentAmount,
      payment_type: paymentType,
      items,
      user_id: userId,
    });
  }

  static beginCheckoutEvent(cartValue, items) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'begin_checkout', {
      currency: 'UYU',
      value: cartValue,
      items,
    });
  }

  static removeFromCartEvent(price, item) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'remove_from_cart', {
      currency: 'UYU',
      value: price,
      items: [item],
    });
  }

  static customEvent(event, payload) {
    if (!window.gtag || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', event, payload);
  }
}

export { GA4 };



// WEBPACK FOOTER //
// ./src/helpers/GA4.js